var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", [
      _c("div", [
        _c("div", { staticClass: "d-flex flex-column feedback-container" }, [
          _c("div", { staticClass: "d-flex flex-column gap-5" }, [
            _c(
              "div",
              {
                staticClass:
                  "font-size-150 d-inline-flex align-items-center gap-10px",
              },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "24",
                      height: "24",
                      viewBox: "0 0 24 24",
                    },
                  },
                  [
                    _c(
                      "g",
                      { attrs: { fill: "none", "fill-rule": "evenodd" } },
                      [
                        _c("path", {
                          attrs: {
                            d: "M24 0v24H0V0zM12.594 23.258l-.012.002l-.071.035l-.02.004l-.014-.004l-.071-.036c-.01-.003-.019 0-.024.006l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.016-.018m.264-.113l-.014.002l-.184.093l-.01.01l-.003.011l.018.43l.005.012l.008.008l.201.092c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022m-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.003-.011l.018-.43l-.003-.012l-.01-.01z",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            fill: "currentColor",
                            d: "m20.255 5.52l.087.298l.089.338l.044.185l.089.4l.085.443l.081.485c.026.169.05.345.074.528l.065.572c.08.791.131 1.7.131 2.731s-.05 1.94-.13 2.731l-.066.572c-.023.183-.048.36-.074.528l-.08.485l-.086.443l-.089.4l-.089.36l-.088.317l-.043.144c-.331 1.087-1.464 1.505-2.394 1.195l-1.18-.393l-.4.933a2 2 0 0 1-2.47 1.11l-5.096-1.7a2 2 0 0 1-1.206-2.684l.269-.628L7 15.055l-1.368.456A2 2 0 0 1 3 13.613V9.388A2 2 0 0 1 5.632 7.49L7 7.946l10.861-3.62c.93-.31 2.063.107 2.394 1.194M9.682 15.948l-.335.78l5.096 1.7l.335-.781zm8.706-9.69L8 9.721v3.558l10.388 3.463l.077-.283l.08-.327l.04-.18l.078-.394a17.8 17.8 0 0 0 .076-.439l.07-.485c.112-.847.191-1.887.191-3.134c0-1.246-.08-2.287-.19-3.134l-.071-.485c-.025-.154-.05-.3-.076-.44l-.079-.393l-.08-.349zM5 9.388v4.225l1-.334V9.721z",
                          },
                        }),
                      ]
                    ),
                  ]
                ),
                _vm._v(
                  "\n            " +
                    _vm._s(_vm._f("trans")("Your input matters!")) +
                    "\n          "
                ),
              ]
            ),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                _vm._s(
                  _vm._f("trans")(
                    "Share your thoughts, suggestions, or experiences using our services."
                  )
                )
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n            " +
                  _vm._s(_vm._f("trans")("Your feedback helps us improve.")) +
                  "\n            " +
                  _vm._s(
                    _vm._f("trans")(
                      "Thank you for being a part of our journey!"
                    )
                  ) +
                  "\n          "
              ),
            ]),
          ]),
          _vm._v(" "),
          _vm.currentJob.feedback.submittedFull !== true
            ? _c(
                "div",
                { staticClass: "d-flex flex-column gap-20" },
                [
                  _c("div", { staticClass: "d-flex flex-column gap-10" }, [
                    _c("strong", [
                      _vm._v(_vm._s(_vm._f("trans")("How would you rate us?"))),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "d-flex gap-15" }, [
                      _c(
                        "label",
                        {
                          staticClass: "radio-inline",
                          class: {
                            disabled:
                              _vm.currentJob.feedback.loading === true ||
                              _vm.currentJob.feedback.submittedFull === true,
                          },
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.rating,
                                expression: "rating",
                              },
                            ],
                            staticClass: "feedback-btn-star-5",
                            attrs: { type: "radio", value: "5" },
                            domProps: { checked: _vm._q(_vm.rating, "5") },
                            on: {
                              change: function ($event) {
                                _vm.rating = "5"
                              },
                            },
                          }),
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm._f("trans")("Great")) +
                              "\n              "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "radio-inline",
                          class: {
                            disabled:
                              _vm.currentJob.feedback.loading === true ||
                              _vm.currentJob.feedback.submittedFull === true,
                          },
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.rating,
                                expression: "rating",
                              },
                            ],
                            attrs: { type: "radio", value: "4" },
                            domProps: { checked: _vm._q(_vm.rating, "4") },
                            on: {
                              change: function ($event) {
                                _vm.rating = "4"
                              },
                            },
                          }),
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm._f("trans")("Good")) +
                              "\n              "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "radio-inline",
                          class: {
                            disabled:
                              _vm.currentJob.feedback.loading === true ||
                              _vm.currentJob.feedback.submittedFull === true,
                          },
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.rating,
                                expression: "rating",
                              },
                            ],
                            attrs: { type: "radio", value: "3" },
                            domProps: { checked: _vm._q(_vm.rating, "3") },
                            on: {
                              change: function ($event) {
                                _vm.rating = "3"
                              },
                            },
                          }),
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm._f("trans")("Medium")) +
                              "\n              "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "radio-inline",
                          class: {
                            disabled:
                              _vm.currentJob.feedback.loading === true ||
                              _vm.currentJob.feedback.submittedFull === true,
                          },
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.rating,
                                expression: "rating",
                              },
                            ],
                            attrs: { type: "radio", value: "2" },
                            domProps: { checked: _vm._q(_vm.rating, "2") },
                            on: {
                              change: function ($event) {
                                _vm.rating = "2"
                              },
                            },
                          }),
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm._f("trans")("Bad")) +
                              "\n              "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "label",
                        {
                          staticClass: "radio-inline",
                          class: {
                            disabled:
                              _vm.currentJob.feedback.loading === true ||
                              _vm.currentJob.feedback.submittedFull === true,
                          },
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.rating,
                                expression: "rating",
                              },
                            ],
                            attrs: { type: "radio", value: "1" },
                            domProps: { checked: _vm._q(_vm.rating, "1") },
                            on: {
                              change: function ($event) {
                                _vm.rating = "1"
                              },
                            },
                          }),
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm._f("trans")("Worse")) +
                              "\n              "
                          ),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("TextArea", {
                    staticClass: "w-100 feedback-text-area",
                    class: {
                      disabled:
                        _vm.currentJob.feedback.loading === true ||
                        _vm.currentJob.feedback.submittedFull === true,
                    },
                    attrs: {
                      "border-class": "br-4",
                      label: _vm.placeholder,
                      "max-characters": 4000,
                      rows: "4",
                      value: _vm.message,
                      aiCustom: true,
                      disabled:
                        _vm.currentJob.feedback.loading === true ||
                        _vm.currentJob.feedback.submittedFull === true,
                      name: "prompt",
                      id: "feedback-form-textarea",
                      type: "text",
                    },
                    model: {
                      value: _vm.message,
                      callback: function ($$v) {
                        _vm.message = $$v
                      },
                      expression: "message",
                    },
                  }),
                ],
                1
              )
            : _c("div", [
                _c(
                  "div",
                  {
                    staticClass:
                      "alert alert-info feedback-info d-flex gap-20 m-0 p-20",
                  },
                  [
                    _c("div", { staticClass: "icon-box" }, [
                      _c(
                        "svg",
                        {
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            width: "42",
                            height: "42",
                            viewBox: "0 0 42 42",
                            fill: "none",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              d: "M21 0.5C9.6963 0.5 0.5 9.6963 0.5 21C0.5 32.3037 9.6963 41.5 21 41.5C32.3037 41.5 41.5 32.3037 41.5 21C41.5 9.6963 32.3037 0.5 21 0.5ZM9.59175 13.7573C10.1429 13.1905 10.8925 12.8594 11.6827 12.8338C12.473 12.8082 13.2424 13.09 13.8291 13.62C14.4068 13.0822 15.1702 12.7888 15.9593 12.8014C16.7485 12.814 17.5022 13.1316 18.0624 13.6876C19.2862 14.9012 19.3006 16.8057 18.0992 18.0295L13.8967 22.2997L9.62865 18.0972C9.33807 17.8165 9.10631 17.4807 8.9469 17.1095C8.78749 16.7383 8.70362 16.339 8.70018 15.935C8.69675 15.531 8.77382 15.1304 8.92689 14.7565C9.07997 14.3826 9.30599 14.0429 9.59175 13.7573ZM21 33.3C12.8 33.3 10.75 25.1 10.75 25.1H31.25C31.25 25.1 29.2 33.3 21 33.3ZM32.4492 18.0295L28.2467 22.2997L23.9786 18.0972C23.6882 17.8165 23.4565 17.4808 23.2971 17.1097C23.1376 16.7385 23.0537 16.3394 23.05 15.9354C23.0464 15.5315 23.1232 15.1309 23.2759 14.757C23.4287 14.383 23.6543 14.0432 23.9397 13.7573C24.491 13.1899 25.2409 12.8585 26.0317 12.8328C26.8224 12.8072 27.5922 13.0894 28.1791 13.62C28.7568 13.0822 29.5202 12.7888 30.3093 12.8014C31.0985 12.814 31.8522 13.1316 32.4123 13.6876C33.6362 14.8992 33.6526 16.8057 32.4492 18.0295Z",
                              fill: "#FBFBFB",
                            },
                          }),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "d-flex flex-column gap-10" }, [
                      _c("strong", { staticClass: "font-size-125" }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("trans")(
                              "You are awesome, thank you for your rating!"
                            )
                          )
                        ),
                      ]),
                      _vm._v(" "),
                      _c("p", {
                        domProps: {
                          innerHTML: _vm._s(_vm.reputationRatingText),
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "text-decoration-none",
                          attrs: {
                            href: _vm.trustPage.url,
                            target: "_blank",
                            rel: "noreferrer",
                          },
                          on: { click: _vm.clickTrustPageLink },
                        },
                        [
                          _c("strong", { staticClass: "text-info" }, [
                            _vm._v(_vm._s(_vm.trustPage.url)),
                          ]),
                        ]
                      ),
                    ]),
                  ]
                ),
              ]),
          _vm._v(" "),
          _vm.selectRatingError
            ? _c("div", { staticClass: "alert alert-warning" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm._f("trans")(
                        "Please enter a rating before submitting your feedback!"
                      )
                    ) +
                    "\n        "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.currentJob.feedback.loading === true
            ? _c("div", { staticClass: "alert alert-info" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm._f("trans")("Submitting your feedback..")) +
                    "\n        "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.currentJob.feedback.submittedFull !== true
            ? _c("div", [
                _c(
                  "button",
                  {
                    staticClass: "btn",
                    class: {
                      disabled: _vm.currentJob.feedback.loading === true,
                      "d-none": _vm.currentJob.feedback.submittedFull === true,
                    },
                    attrs: { id: "feedback-submit-btn-main" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.send.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c("strong", [
                      _vm._v(" " + _vm._s(_vm._f("trans")("Submit"))),
                    ]),
                    _vm._v(" "),
                    !_vm.currentJob.feedback.loading
                      ? _c("i", { staticClass: "fa fa-arrow-right" })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.currentJob.feedback.loading
                      ? _c("i", {
                          staticClass: "fa fa-spin btn-loading-animation",
                        })
                      : _vm._e(),
                  ]
                ),
              ])
            : _vm._e(),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }